export default {
  namespaced: true,
  actions: {
    update({}, candidate) {
      return Vue.$http.patch('candidate/candidate', { candidate })
    }
  }
}
